import { useLocale } from 'use-intl'
import { resolveImplementedLocale } from '~/lib/i18n/shared'

const copy = {
  'en': {
    lead: 'Review the policies required for registration:',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    disclaimer: 'Disclaimer',
  },
  'zh-CN': {
    lead: '注册前请查看并同意：',
    terms: '服务条款',
    privacy: '隐私政策',
    disclaimer: '免责声明',
  },
} as const

export function RegistrationLegalNote() {
  const locale = resolveImplementedLocale(useLocale())
  const text = copy[locale]
  const legalBasePath = locale === 'zh-CN' ? '/zh-CN/legal' : '/legal'
  const linkClassName = 'inline-flex min-h-11 items-center px-2 font-semibold text-foreground underline decoration-primary/60 underline-offset-4 hover:decoration-primary'

  return (
    <div className="mt-4 max-w-md text-center text-xs leading-5 text-muted">
      <p>{text.lead}</p>
      <nav aria-label={text.lead} className="mt-1 flex flex-wrap justify-center gap-x-1">
        <a href={`${legalBasePath}/terms`} className={linkClassName}>{text.terms}</a>
        <a href={`${legalBasePath}/privacy`} className={linkClassName}>{text.privacy}</a>
        <a href={`${legalBasePath}/disclaimer`} className={linkClassName}>{text.disclaimer}</a>
      </nav>
    </div>
  )
}
